import axios from 'axios';

let baseUrl = 'http://localhost:3000/';

if (process.env.API_ENV === 'wbab') {
    baseUrl = 'https://api.webuyanybike.com/';
} else if (process.env.API_ENV === 'production') {
    baseUrl = 'https://connect.superbikefactory.co.uk/';
} else if (process.env.API_ENV === 'preprod') {
    baseUrl = 'https://connect-preprod.superbikefactory.co.uk/';
} else if (process.env.API_ENV === 'staging') {
    baseUrl = 'https://staging.superbikefactory.co.uk/';
} else if (process.env.API_ENV === 'development') {
    baseUrl = 'https://development.superbikefactory.co.uk/';
}

if (process.env.SETTINGS !== undefined) {
    if (process.env.SETTINGS === 'test' || process.env.SETTINGS === 'staging') {
        baseUrl = 'https://staging.connect.superbikefactory.co.uk/';
    }

    if (process.env.SETTINGS === 'preprod') {
        baseUrl = 'https://connect-preprod.superbikefactory.co.uk/';
    }
}

export const sendCreateAccountRequest = (login, password, first_name, last_name) => (
    axios({
        method: 'post',
        url: `${baseUrl}user/create`,
        data: {
            create: {
                person: { first_name, last_name },
                login,
                password,
            },
        },
    }).then(response => response.data).catch(error => error));

export const sendResetPasswordRequest = (token, new_password) => (
    axios({
        method: 'post',
        url: `${baseUrl}auth/reset-password`,
        data: { token, new_password },
    }).then(response => response.data).catch(error => error));

export const sendForgotPasswordRequest = email => (
    axios({
        method: 'post',
        url: `${baseUrl}auth/forgot-password`,
        data: { login: email },
    }).then(response => response.data).catch(error => error));

export const sendVerifyAccountRequest = token => (
    axios({
        method: 'post',
        url: `${baseUrl}user/verify-account`,
        data: { token },
    }).then(response => response.data).catch(error => error));



// WEBPACK FOOTER //
// ./src/modules/App/requests/account_requests.js